"use client";

import { Typography } from "@tosize/ui";
import { useCabinet } from "./Context";

export function CabinetTitle({ name, title }: { name?: string; title: string }) {
	const { canvasIsCustomized } = useCabinet();

	return (
		<Typography
			variant="h1"
			className="target container text-center [--scroll-margin-top:calc(var(--header-y)+1rem)]"
			id="product-information"
		>
			{!canvasIsCustomized && name ? name : title}
		</Typography>
	);
}
